import React from 'react';
import Chart from "react-apexcharts";
import global from '../../../common/utility/global';

export default function GraficoPie(props) {

const options = {
  title: {
    text: props.title,
    align: 'center',
    style: {
      fontSize: "18px",
      fontWeight: "bold",
      fontFamily: undefined,
      color: "#263238",
    },
  },
  chart: {
    width: 380,
    type: 'pie',
  },
  series: props.series,
  labels: props.labels,
  colors: ['#f97316', '#3b82f6'], // PEN (naranja), USD (celeste)

  dataLabels: {
    enabled: true,
    formatter: function (val, opts) {
      // Muestra el valor real en lugar del %
      const totalValue = opts.w.config.series[opts.seriesIndex] || 0;
      const label = opts.w.config.labels[opts.seriesIndex];
      return `${label}: ${totalValue.toFixed(2)}`;
    },
    style: {
      fontSize: '14px',
      fontWeight: 'bold'
    }
  },

  tooltip: {
    y: {
      formatter: function (val) {
        return ` ${val.toFixed(2)}`; // o "$" para USD si quieres formatear diferente
      }
    }
  },

  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 200
      },
      legend: {
        position: 'bottom'
      }
    }
  }]
};

  return (
    <div id="chart">
      <Chart options={options} series={options.series} type="pie" height={250} />
    </div>
  );
}